var map = {
	"./eng_1.webp": 989,
	"./eng_2.webp": 9,
	"./eng_3.webp": 215,
	"./eng_4.webp": 367,
	"./eng_5.webp": 498,
	"./eng_6.webp": 880,
	"./new_1.webp": 753,
	"./new_2.webp": 1,
	"./new_3.webp": 126,
	"./new_4.webp": 646,
	"./new_5.webp": 717,
	"./new_6.webp": 397,
	"./new_eng_1.webp": 644,
	"./new_eng_2.webp": 212,
	"./new_eng_3.webp": 641,
	"./new_eng_4.webp": 191,
	"./new_eng_5.webp": 51,
	"./new_eng_6.webp": 643,
	"./ru_1.webp": 997,
	"./ru_2.webp": 379,
	"./ru_3.webp": 83,
	"./ru_4.webp": 318,
	"./ru_5.webp": 6,
	"./ru_6.webp": 335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 214;